import { DATA_ROUTE, HOME_ROUTE, PURCHASE_ROUTE } from '../constants/Routes';

export const routeMapper = (location) => {
  switch (location) {
    case DATA_ROUTE:
      return 'Mis Datos';
    case HOME_ROUTE:
      return 'Mis Datos';
    case PURCHASE_ROUTE:
      return 'Mis Compras';
  }
};

export const classSelector = (location, activeLocation) => {
  if (activeLocation === DATA_ROUTE && location === HOME_ROUTE) return true;
  if (location === activeLocation) return true;
  else return false;
};
